import React from 'react'

function detail_1(params) {
  return (
    <>
      <div id='detail_1'>
        <div className='row pt-5'>
          <div className='col-sm-8 col-12 mx-auto py-sm-5 pt-4 pb-3'>
            <h1 className='text-center'>Motto of VB DACE</h1>
            <p className='text-center px-4'>
              VB DACE as a brand, strongly believes in making Cookware that are non-toxic,
              healthy to use, aesthetically pleasing, completely user-friendly and built
              to last for ages!
              <br />
              <br />
              Each of our products are designed by the man himself (Chef Venkatesh Bhat),
              who has an eye for detail, and fine-tuned to precision over multiple iterations
              before it reaches your hand!Be ready to level up your cooking experience with
              our Premium Products that are sure to be a part of your HEIRLOOM collection!
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export const DetailOne = detail_1
